// Re-export the hook from the context for convenience
export { useRuntimeConfig } from '../contexts/runtimeConfig';
